import React, { useRef, useState } from "react";

import { PageFrame } from "components/auth/PageFrame";
import { CircularProgress, TextField } from "@mui/material";
import { requestPasswordRecover } from "libLegacy/api/auth";
import { LOGIN, RECOVERY_LINK_SENT } from "routers/routePaths";
import { useSetError, useErrorInfo } from "contexts/ErrorContext";
import { CustomCodes } from "contexts/ErrorContextData";

const PAGE_DATA = {
  title: "Recuperar senha",
  subtitle:
    "Preencha com o seu e-mail de acesso e te enviaremos um link de recuperação de senha.",
  buttonText: "Enviar link de recuperação",
  anchorText: "Cancelar",
  nextTo: RECOVERY_LINK_SENT,
  cancelTo: LOGIN,
};

export const PasswordRecovery = ({ history }) => {
  const { title, subtitle, buttonText, anchorText, cancelTo, nextTo } =
    PAGE_DATA;
  const refEmail = useRef<HTMLInputElement>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const setGlobalError = useSetError();
  const errorInfo = useErrorInfo();
  const hasFormError = errorInfo?.code === CustomCodes.INVALID_FORM;

  const handleClick = async () => {
    const requestEmail = refEmail.current?.value;
    const isEmailValid = !refEmail.current?.validity.typeMismatch;
    if (requestEmail && isEmailValid) {
      setIsLoading(true);
      try {
        await requestPasswordRecover(requestEmail);
        history.push(nextTo);
      } catch (error) {
        // @ts-expect-error
        setGlobalError(error.response?.data?.error);
        setIsLoading(false);
      }
    } else {
      setGlobalError(CustomCodes.INCOMPLETE_FORM);
    }
  };

  return (
    <PageFrame
      title={title}
      subtitle={subtitle}
      buttonData={{
        text: isLoading ? (
          <CircularProgress size={24} color="secondary" />
        ) : (
          buttonText
        ),
        onClick: handleClick,
      }}
      anchorData={{ text: anchorText, to: cancelTo }}
    >
      <TextField
        autoFocus
        inputRef={refEmail}
        type="email"
        variant="outlined"
        label="Seu e-mail"
        fullWidth
        error={hasFormError}
      />
    </PageFrame>
  );
};
